var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import styled, { css } from '@xstyled/styled-components';
import { useLocation } from 'react-router';
import Link from '../../Link/Link';
var StyledLink = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  border-top: ", ";\n  padding-top: ", ";\n  color: typoPrimary;\n\n  :hover > * {\n    color: typoPrimary;\n    background-color: bgLightGray1;\n    border-radius: 6px;\n  }\n  ", "\n"], ["\n  display: block;\n  border-top: ", ";\n  padding-top: ", ";\n  color: typoPrimary;\n\n  :hover > * {\n    color: typoPrimary;\n    background-color: bgLightGray1;\n    border-radius: 6px;\n  }\n  ", "\n"])), function (_a) {
    var $hasSeparator = _a.$hasSeparator;
    return ($hasSeparator ? '1px solid #D2D8DF' : 'none');
}, function (_a) {
    var $hasSeparator = _a.$hasSeparator;
    return ($hasSeparator ? '4px' : '0');
}, function (_a) {
    var $isActive = _a.$isActive;
    return $isActive && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: red1;\n    color: white;\n    border-radius: 6px;\n    :hover {\n      & svg {\n        stroke: typoPrimary;\n      }\n    }\n    & svg {\n      stroke: white;\n    }\n  }\n"], ["\n    background-color: red1;\n    color: white;\n    border-radius: 6px;\n    :hover {\n      & svg {\n        stroke: typoPrimary;\n      }\n    }\n    & svg {\n      stroke: white;\n    }\n  }\n"])));
});
var MenuItem = function (_a) {
    var item = _a.item, ItemComponent = _a.ItemComponent, onClose = _a.onClose;
    var onClick = item.onClick, link = item.link, hasSeparator = item.hasSeparator, name = item.name, autoClose = item.autoClose;
    var location = useLocation();
    var isActive = link === location.pathname;
    var onClickCallback = useCallback(function (e) {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
        if (autoClose && onClose) {
            setTimeout(function () {
                onClose();
            }, 200);
        }
    }, [autoClose, onClick, onClose]);
    return (_jsx(StyledLink, { to: link, "$isActive": isActive, onClick: onClickCallback, "$hasSeparator": !!hasSeparator, "data-cy": name, size: "inherit", children: _jsx(ItemComponent, __assign({}, item)) }));
};
export default MenuItem;
var templateObject_1, templateObject_2;
